import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell } from '@fortawesome/free-solid-svg-icons'

const NotificationList = (props) => {
  return (
    <div className="card box border-0 mb-3" data-aos="fade-up" data-aos-duration="400">
        <div className="card-body">
        <h4 className="card-title mb-2"> <FontAwesomeIcon icon={faBell} className="me-2"/> {props.title} </h4>
        <p className="card-text m-0  mb-2 text-secondary">{props.description}</p>
        </div>
    </div>
  )
}

export default NotificationList
